<template>
  <div class="page-wrapper mt-3" style="width: 100%">
    <PageTitle title="Управление пользователями системы" />

    <!-- Панель поиска и добавления -->
    <v-card variant="outlined" class="ma-2 pa-4 bg-white">
      <v-row align="center">
        <v-col cols="12" sm="8">
          <v-text-field
            v-model="searchQuery"
            prepend-inner-icon="mdi-account-search-outline"
            label="Поиск по Фамилии, Имени или Email..."
            variant="outlined"
            density="comfortable"
            hide-details
            clearable
            @input="onSearchInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" class="text-sm-right">
          <v-btn color="deep-orange-darken-1" prepend-icon="mdi-account-plus" variant="flat" @click="openUserDialog()">
            Добавить пользователя
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Серверная таблица пользователей -->
    <div class="page-wrapper mt-3 w-100">
      <Vue3EasyDataTable
        class="ma-2"
        :headers="headers"
        :items="users"
        :loading="loading"
        :server-items-length="totalElements"
        v-model:server-options="serverOptions"
        buttons-pagination
        alternating
      >
        <!-- Форматирование вывода ФИО -->
        <template #item-lastname="item">
          <strong>{{ item.lastname }}</strong> {{ item.firstname }} {{ item.secname || '' }}
        </template>

        <!-- Отображение ролей в виде красивых чипов -->
<template #item-roles="{ roles }">
  <v-chip
    v-for="role in parseRoles(roles)"
    :key="role"
    size="x-small"
    :color="role === 'ROLE_ADMIN' ? 'red' : (role === 'ROLE_TEACHER' ? 'purple' : 'green')"
    variant="flat"
    class="ma-1 font-weight-bold"
  >
    {{ role === 'ROLE_ADMIN' ? 'Администратор' : (role === 'ROLE_TEACHER' ? 'Преподаватель' : 'Обучающийся') }}
  </v-chip>
</template>


     <!-- Отображение групп (ИСПРАВЛЕНО: v-if перенесен на wrapper) -->
     <template #item-groupNames="{ groupNames }">
       <!-- Переносим v-if на невидимый контейнер-обертку -->
       <template v-if="groupNames && groupNames !== 'Нет групп'">
         <v-chip
           v-for="g in groupNames.split(', ')"
           :key="g"
           size="x-small"
           color="blue"
           variant="tonal"
           class="ma-1"
         >
           {{ g }}
         </v-chip>
       </template>
       <span v-else class="text-caption text-grey font-italic pl-1">Нет групп</span>
     </template>

        <!-- Действие над пользователем -->
        <template #item-actions="item">
          <v-btn icon="mdi-pencil-outline" variant="text" color="secondary" density="compact" @click="openUserDialog(item)"></v-btn>
        </template>
      </Vue3EasyDataTable>
    </div>

    <!-- МОДАЛКА: Создание / Редактирование пользователя -->
    <v-dialog v-model="userDialog" max-width="600px" persistent>
      <v-card >
        <v-card-title class="text-h5 font-weight-bold bg-deep-orange-darken-1">
          {{ userForm.id ? 'Редактировать профиль' : 'Регистрация пользователя' }}
        </v-card-title>

        <v-card-text>
          <v-form ref="formRef" lazy-validation>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field v-model="userForm.lastname" label="Фамилия*" variant="outlined" :rules="[v => !!v || 'Обязательно']"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="userForm.firstname" label="Имя*" variant="outlined" :rules="[v => !!v || 'Обязательно']"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="userForm.secname" label="Отчество" variant="outlined"></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- Поле ввода Email (username на бэкенде) с жестким Regex правилом -->
                <v-text-field
                  v-model="userForm.username"
                  label="Email (Логин в системе)*"
                  variant="outlined"
                  prepend-inner-icon="mdi-email-outline"
                  :rules="emailRules"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="userForm.password"
                  label="Пароль*"
                  type="password"
                  variant="outlined"
                  prepend-inner-icon="mdi-lock-outline"
                  :hint="userForm.id ? 'Оставьте пустым, если не хотите менять' : 'Минимум 6 знаков, буквы и цифры'"
                  :required="!userForm.id"
                  :rules="userForm.id ? [] : [v => !!v || 'Пароль обязателен!']"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- Множественный выбор ролей на базе твоего Enum -->
                <v-select
                  v-model="userForm.roles"
                  :items="['ROLE_USER', 'ROLE_TEACHER', 'ROLE_ADMIN']"
                  label="Роли в системе*"
                  multiple
                  chips
                  variant="outlined"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" v-if="userForm.id">
                <v-checkbox v-model="userForm.active" label="Учетная запись активна" color="success" hide-details></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="grey-darken-1" variant="text" @click="userDialog = false">Отмена</v-btn>
          <v-btn color="deep-orange-darken-1" variant="flat" @click="saveUser">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="1500">
      {{ snackbarMessage }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">Закрыть</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>


<script setup>
import { ref, watch, onMounted } from 'vue';
import PageTitle from "@/elements/PageTitle.vue";
import Vue3EasyDataTable from "vue3-easy-data-table";
import { customAxios } from "@/service/customAxios";
import { usePopupStore } from "@/store/popup";
import { debounce } from "@/util/common";

const { showError } = usePopupStore();

// Реактивные переменные таблицы
const users = ref([]);
const loading = ref(false);
const totalElements = ref(0);
const searchQuery = ref('');

// Переменные окон уведомлений и форм
const userDialog = ref(false);
const snackbar = ref(false);
const snackbarMessage = ref('');
const formRef = ref(null);

// Модель для формы создания/редактирования (DTO)
const userForm = ref({
  id: null,
  lastname: '',
  firstname: '',
  secname: '',
  username: '', // email
  password: '',
  roles: ['ROLE_USER'],
  active: true
});

// Опции пагинации для Vue3EasyDataTable
const serverOptions = ref({
  page: 1,
  rowsPerPage: 10,
});

// Заголовки таблицы
const headers = [
  { text: "ID", value: "id" },
  { text: "Пользователь (ФИО)", value: "lastname" },
  { text: "Логин / Email", value: "username" },
  { text: "Роли", value: "roles" },
  { text: "Состоит в группах", value: "groupNames" },
  { text: "Действие", value: "actions" },
];

// Жесткая валидация Email регулярным выражением на фронтенде
const emailRules = [
  v => !!v || 'Email обязателен для заполнения!',
  v => /^[A-Za-z0-9+_.-]+@(.+)$/.test(v) || 'Некорректный формат Email (образец: ivanov@mail.ru)'
];

/**
 * 1. Получение пагинированной страницы пользователей с сервера
 */
async function fetchUsersPage() {
  loading.value = true;
  try {
    const payload = {
      search: searchQuery.value || null,
      page: serverOptions.value.page - 1, // В Java индексация с 0
      size: serverOptions.value.rowsPerPage
    };

    const r = await customAxios.post('/person/page', payload);
    if (r.status === 200 && r.data) {
      users.value = r.data.content || [];
      totalElements.value = r.data.totalElements || 0;
    }
  } catch (e) {
    showError(e);
  } finally {
    loading.value = false;
  }
}

/**
 * 2. Парсинг ролей для чипов
 * Твой бэкенд отдает роли как строку "[ROLE_USER, ROLE_ADMIN]".
 * Этот метод превращает ее в чистый JS-массив.
 */
function parseRoles(rolesData) {
  if (!rolesData) return ['ROLE_USER'];
  if (Array.isArray(rolesData)) return rolesData;
  // ИСПРАВЛЕНО: Убран лишний бэкслеш перед первой скобкой
  return rolesData.replace(/[[\]]/g, '').split(',').map(r => r.trim());

}

/**
 * 3. Открытие модального окна (Создание или Редактирование)
 */
function openUserDialog(user = null) {
  if (user) {
    userForm.value = {
      id: user.id,
      lastname: user.lastname,
      firstname: user.firstname,
      secname: user.secname || '',
      username: user.username,
      password: '', // Пароль оставляем пустым при редактировании
      roles: parseRoles(user.roles),
      active: user.active !== false
    };
  } else {
    userForm.value = { id: null, lastname: '', firstname: '', secname: '', username: '', password: '', roles: ['ROLE_USER'], active: true };
  }
  userDialog.value = true;
  // Сбрасываем старые ошибки валидации формы Vuetify, если они были
  if (formRef.value) formRef.value.resetValidation();
}

/**
 * 4. Отправка данных на бэкенд (POST или PUT)
 */
async function saveUser() {

  const { valid } = await formRef.value.validate();
  if (!valid) return;

  try {
    if (userForm.value.id) {
      await customAxios.put(`/person/${userForm.value.id}`, userForm.value);
      snackbarMessage.value = "Данные пользователя успешно обновлены";
    } else {
      await customAxios.post('/person', userForm.value);
      snackbarMessage.value = "Пользователь зарегистрирован в системе";
    }
    userDialog.value = false;
    snackbar.value = true;
    await fetchUsersPage(); // Обновляем текущую страницу
  } catch (e) {
    showError(e);
  }
}

// Задержка поисковых запросов (Debounce)
const onSearchInput = debounce(() => {
  serverOptions.value.page = 1;
  fetchUsersPage();
}, 400);


watch(serverOptions, () => {
  fetchUsersPage();
}, { deep: true });

onMounted(fetchUsersPage);
</script>

<style scoped>
/* Убираем лишние отступы под инпутами Vuetify, чтобы верстка была компактной */
:deep(.v-input__details) {
  padding-top: 2px !important;
}
</style>
